<template>
    <div class="container">
<!--        <div class="newsbg">-->
<!--            <img src="../../assets/images/newsbg4.png" width="100%" height="100%"/>-->
<!--            <div class="bgtitle">-->
<!--                <h1>新闻中心</h1>-->
<!--                <span>NEWS&nbsp;&nbsp;&nbsp;&nbsp;CENTER</span>-->
<!--            </div>-->
<!--        </div>-->
      <div :class={banner:true,showBtn:btnFlage} >
        <template>
          <el-carousel arrow="always" class="bannerbox" :height="imgHeight + 'px'" style="width:100%">
            <el-carousel-item v-for="item in bannerList" :key="item.id">
              <div class="bannermain"><img ref="image" :src="item.url" width="100%" height="auto"/></div>
            </el-carousel-item>
          </el-carousel>
        </template>
      </div>
        <!-- <div class="navcontainer">
            <div class="navmain">
                <span>首页</span>
                <span>/</span>
                <span>新闻中心</span>
                <span>/</span>
                <span style="color:rgb(73,129,243)">公司新闻</span>
            </div>
        </div> -->
        <div class="newsbody">
            <!-- 装饰部分 -->
            <!-- 主要内容 -->
            <div class="newscontent">
                <div class="item" v-for="(item,index) in newsData" :key="index" @click="handletoSde(item.id)">
                    <div class="date">
                        <!-- <div class="diract">
                            <p>{{item.date}}</p>
                            <span>{{item.year}}</span>
                        </div> -->
                    </div>
                    <div class="itemimg">
                        <img :src="item.img"/>
                    </div>
                    <div class="itemcontent">
                        <h1>{{item.title | ellTitle}}</h1>
                        <div class="lineOne"></div>
                        <div class="contentText">
                            <span>
                                {{item.introduction | ellInt}}
                            </span>
                        </div>
                        <div class="lineTwo"></div>
                        <div class="details">
                            <span>了解详情</span>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <div class="bottomPage">
            <pagination
                v-show="total > 0"
                :total="total"
                :page.sync="queryForm.pageNum"
                :limit.sync="queryForm.pageSize"
                @pagination="getNewsInfo"
            />
        </div>
    </div>
</template>
<script>
import axios from 'axios'
export default {
    data() {
        return{
            newsData:[],
            total:0,
            queryForm:{
                pageNum:1,
                pageSize:9
            },
          imgHeight:"800",
          bannerList:[],
          btnFlage:false
        }
    },
    filters:{
        ellInt(value){
            if (!value) return ''
            if (value.length > 80) {
                return value.slice(0,80) + '...'
            }
            return value
        },
        ellTitle(value){
            if (!value) return ''
            if (value.length > 23) {
                return value.slice(0,23) + '...'
            }
            return value
        },
    },
    methods:{
      initBanner(){
        let that=this;
        axios.get('http://www.thingo.com.cn/thingo-server/website/news/center/banner').then((res) => {
          that.bannerList = res.data.data;
          if (that.bannerList.length === 1) {
            that.btnFlage = true
          }
          window.addEventListener("resize",this.resize,true)
        })
      },
        backtop(){
           window.onbeforeunload = function(){
               window.scrollTo(0,0)
           }
       },
        handletoSde(id){
            axios.get('http://www.thingo.com.cn/thingo-server/website/news/center/details/' + id).then(()=>{
                this.$router.push({
                    path:'/news/newsdetails',
                    query:{
                        newsId:id
                    },
                })
            })

        },
        getNewsInfo(){

            axios({
                url:'http://www.thingo.com.cn/thingo-server/website/news/center/list',
                params:this.queryForm,
                method:'get'
            }).then(res => {
                this.newsData = res.data.rows
                this.total = res.data.total
                console.log(this.total)
                this.newsData.forEach(item => {
                    item.year = item.createTime.slice(0,7)
                    item.date = item.createTime.slice(8,10)
                })
            })

        },
        goCenter(){
          document.body.scrollTop = 370
          document.documentElement.scrollTop = 370
          window.pageXOffset = 370
        },
        imgLoad(){
          // setTimeout(()=>{
          //   this.imgHeight = this.$refs.image[0].height
          // },500)
          let scrollWidth = document.body.scrollWidth
          if (scrollWidth < 1366) {
            setTimeout(()=>{
              this.imgHeight = this.$refs.image[0].height
            },500)
          } else {
            setTimeout(()=>{
              this.imgHeight = this.$refs.image[0].height
            },200)
          }
        },
        resize(){
          this.imgHeight = this.$refs.image[0].height
        }
    },
    mounted(){
      this.initBanner()
      this.imgLoad()
      this.$EventBus.$on("goNewsCen",()=>{
        this.goCenter()
      })
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
        window.pageXOffset = 0
        this.getNewsInfo()
        this.backtop()
    },
  beforeDestroy() {
    window.removeEventListener('resize',this.resize,true)
    this.$EventBus.$off('goNewsCen')
  }
}
</script>

<style scoped>
.banner{
  width: 100%;
  height: auto;
}
    .bottomPage{
        width: 100%;
    }
    .newsbg{
        width: 100%;
        height: auto;
    }
    .newsbg .bgtitle{
        width: 240px;
        height: auto;
        position: absolute;
        left: 20%;
        top: 20%;
    }
    .newsbg .bgtitle h1{
        font-size: 50px;
        font-family: 'PingFangSC-Medium';
        color: #ffffff;
        margin: 0 0 30px 0;
        padding: 0;
        font-weight: 400;
    }
    .newsbg .bgtitle span{
        font-size: 28px;
        font-family: 'Arial-BoldMT';
        color: #ffffff;
    }
    .navcontainer{
        width: 100%;
        height: 50px;
        background-color: rgb(246,248,251);
    }
    .navcontainer .navmain{
        width: 300px;
        height: 50px;
        display: flex;
        align-items: center;
        position: relative;
        left: 200px;
    }
    .navcontainer .navmain span{
        font-family: 'PingFang SC', 'PingFang SC-Regular';
        margin-right: 5px;
        font-size: 16px;
    }
    .newsbody{
        width: 100%;
        height: auto;
    }
    .newsbody .newscontent{
        width: 1200px;
        height: auto;
        margin: 0 auto;
    }
    .newsbody .newscontent .item{
        width: 100%;
        height: 272px;
        display: flex;
        margin-top: 50px;
        margin-bottom: 50px;
        cursor: pointer;
    }
    .newsbody .newscontent .item .date{
        width: 60px;
        height: 272;
        margin-right: 30px;

    }
    .newsbody .newscontent .item .date .diract{
        width: 100%;
        position: relative;
        top: 90px;
    }
    .newsbody .newscontent .item .date p{
        font-size: 50px;
        font-family: 'DINPro-Medium';
        color: #000000;
        padding: 0;
        margin: 0;
    }
    .newsbody .newscontent .item .date span{
        font-size: 16px;
        font-family: 'DINPro-Medium';
        color: #3e4956;
    }
    .newsbody .newscontent .item .itemimg{
        width: 37%;
        /* height: auto; */
        height: 100%;
        margin-right: 30px;
    }
    .newsbody .newscontent .item .itemimg img{
        width: 100%;
        height: 100%;
    }
    .newsbody .newscontent .item .itemcontent{
        width: 607px;
        height: 272px;
    }
    .newsbody .newscontent .item .itemcontent h1{
        font-size: 24px;
        font-family: 'PingFang SC', 'PingFang SC-Bold';
        font-weight: 700;
        color: #000000;
    }
    .newsbody .newscontent .item .itemcontent .lineOne{
        width: 35px;
        height: 3px;
        background: linear-gradient(270deg,#2664fe 0%, #34e5f9 100%);
        border-radius: 2px;
        margin-bottom: 20px;
    }
    .newsbody .newscontent .item .itemcontent span{
        font-size: 14px;
        font-family: 'PingFang SC', 'PingFang SC-Regular';
        font-weight: 400;
        color: #4f5768;
    }
    .newsbody .newscontent .item .itemcontent .contentText{
        width: 576px;
        height: 60px;
        margin-bottom: 20px;
    }
    .newsbody .newscontent .item .itemcontent .lineTwo{
        width: 100%;
        height: 1px;
        border: 1px dashed #cbd0d9;
    }
    .newsbody .newscontent .item .itemcontent .details{
        width: 150px;
        height: 25px;
        position: relative;
        top: 60px;
    }
    .newsbody .newscontent .item .itemcontent .details span{
        font-size: 18px;
        font-family: 'PingFang SC', 'PingFang SC-Medium';
        font-weight: 500;
        color: #3963ae;
        cursor: pointer;
    }
    .bottomPage{
        text-align: center;
    }
    @media screen and (max-width: 1200px) {
        .newsbody .newscontent{
            width: 100%;
        }
    }
    @media screen and (max-width: 996px) {
        .newsbg .bgtitle{
            top: 10%;
            left: 10%;
        }
        .newsbody .newscontent .item {
            display: block;
            width: 50%;
            margin: 20px auto;
            height: auto;
            padding: 10px;
            box-sizing: border-box;
            box-shadow: 0px 0px 10px 2px #cccccc;
            border-radius: 5px;
        }
        .newsbody .newscontent .item .itemimg{
            width: 100%;
        }
        .newsbody .newscontent .item .itemcontent h1{
            font-size: 16px;
        }
        .newsbody .newscontent .item .itemcontent .lineTwo{
            display: none;
        }
        .newsbody .newscontent .item .itemcontent .details{
            display: none;
        }
        .newsbody .newscontent .item .itemcontent{
            width: 100%;
            height: auto;
        }
        .newsbody .newscontent .item .itemcontent span{
            font-size: 13px;
        }
        .newsbody .newscontent .item .itemcontent .contentText{
            width: 100%;
        }
    }
    @media screen and (max-width: 664px) {
        .newsbg .bgtitle{
            top: 12%;
            left: 12%;
        }
        .newsbody .newscontent .item {
            width: 90%;
        }
        .bottomPage >>>.el-pagination__total{
            display: none;
        }
        .bottomPage >>>.el-pagination__sizes{
            display: none;
        }
        .newsbg .bgtitle h1{
            font-size: 30px;
            margin: 0 0 10px 0;

        }
        .newsbg .bgtitle span{
            font-size: 10px;

        }
    }
</style>
